import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable, catchError, throwError } from 'rxjs';
import { NotificationService } from '../services/notification.service';

export function errorInterceptor(
  request: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> {
  const notifications = inject(NotificationService);

  return next(request).pipe(
    catchError((error: HttpErrorResponse) => {
      const isExpectedMembershipSummaryMiss =
        error.status === 404 && request.url.includes('/api/notification/membership-summary');
      if (isExpectedMembershipSummaryMiss) {
        return throwError(() => error);
      }
      const isAgreementSend405 =
        error.status === 405 && request.url.includes('/api/memberships/') && request.url.includes('/agreement/send-to-member');
      if (isAgreementSend405) {
        return throwError(() => error);
      }

      // A failed automatic refresh is reported once against the original request.
      // Session restoration on application startup handles this failure silently.
      if (request.url.includes('/api/auth/admin/refresh')) {
        return throwError(() => error);
      }

      if (error.status === 401) {
        const isAdminLogin = request.url.includes('/api/auth/admin/login');
        notifications.error(
          isAdminLogin
            ? 'Invalid sign-in details. Please check your credentials and try again.'
            : 'Your session has expired. Please sign in again.'
        );
        return throwError(() => error);
      }

      if (error.status === 403) {
        notifications.error('You do not have permission to perform this action.');
        return throwError(() => error);
      }

      if (error.status === 429) {
        notifications.error('Too many attempts. Please wait and try again.');
        return throwError(() => error);
      }

      const isTranslationAssetError = request.url.includes('/assets/i18n/');
      if (isTranslationAssetError) {
        return throwError(() => error);
      }

      const isValidationError = error.status === 400 || error.status === 422;
      const serverMessage =
        typeof error.error === 'string'
          ? error.error.trim()
          : typeof error.error?.message === 'string'
            ? error.error.message.trim()
            : '';
      const message = isValidationError
        ? serverMessage || 'Please check the highlighted fields.'
        : error.status === 404
          ? serverMessage || 'The requested item was not found.'
          : error.status === 409
            ? serverMessage || 'This change conflicts with the current data. Please refresh and try again.'
            : error.status === 0
              ? 'The service is currently unavailable. Please check your connection and try again.'
              : 'An unexpected error occurred. Please try again.';
      notifications.error(message);
      return throwError(() => error);
    })
  );
}
